const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/work-integrations/$integrationId/logs/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/(app)/org/$org/settings/work-integrations/$integrationId/logs/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});